import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AccountPlanItemsService } from './api/accountPlanItems.service';
import { AccountsService } from './api/accounts.service';
import { AttachmentsService } from './api/attachments.service';
import { ClientsService } from './api/clients.service';
import { CompanyAccountsService } from './api/companyAccounts.service';
import { DashboardsService } from './api/dashboards.service';
import { DictionariesService } from './api/dictionaries.service';
import { DocumentService } from './api/document.service';
import { ExchangeService } from './api/exchange.service';
import { MailService } from './api/mail.service';
import { ProfileSettingsService } from './api/profileSettings.service';
import { SecurityService } from './api/security.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
